import { Dialog } from '../controls/dialog.js';

/**
 * Review deletion dialog.
 */
class ReviewDeleteDialog extends Dialog {
  static titleMarkup = `Delete review`;

  static bodyMarkup = `
    <form class='default'>
      <label>
        <span>Are you sure you want to delete the review?<br>
        <span class='delete-dialog-caution'>Caution!</span> This operation can't be undone.
        </span>
      </label>
    </form>
  `;

  static buttons = {
    accept: {
      label: 'Delete',
    },
    cancel: {
      label: 'Cancel',
      default: true,
    },
  };

  set(review) {
    this.#review = review;
  }

  get data() {
    return this.#review;
  }

  static tagName = 'review-delete-dialog';

  #review;
}

ReviewDeleteDialog.defineCustomElement();

export { ReviewDeleteDialog };
